import React from "react"
// UI
import {Accordian} from "@uprise/accordian"
import styled from "styled-components"

const AccordianCustom = ({custom, result}) => {
	const AccordianStyled = styled(Accordian)`
		> div > div:first-child {
			background: unset;
		}
		& h4 {
			width: 100%;
			font-size: 16px;
			margin-top: 8px;
		}
		& img {
			margin-top: 1rem;
		}
	`
	return (
		<>
			{custom ? (
				<AccordianStyled className='m-b-5' content={result} />
			) : (
				<Accordian className='m-b-5' content={result} />
			)}
		</>
	)
}

export default AccordianCustom
